import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { supabaseAdmin } from "@/integrations/supabase/client.server";

const PartnerRequestSchema = z.object({
  company_name: z.string().trim().min(2).max(200),
  contact_name: z.string().trim().min(2).max(120),
  contact_email: z.string().trim().email().max(200),
  contact_phone: z.string().trim().max(40).nullable().optional(),
  country: z.string().trim().max(80).nullable().optional(),
  use_case: z.string().trim().min(10).max(1500),
  estimated_volume: z.string().trim().max(120).nullable().optional(),
  source: z.string().trim().max(60).default("corporate_access"),
});

export const submitPartnerAccessRequest = createServerFn({ method: "POST" })
  .inputValidator((input: unknown) => PartnerRequestSchema.parse(input))
  .handler(async ({ data }) => {
    const { data: row, error } = await supabaseAdmin
      .from("partner_access_requests")
      .insert({
        company_name: data.company_name,
        contact_name: data.contact_name,
        contact_email: data.contact_email,
        contact_phone: data.contact_phone ?? null,
        country: data.country ?? null,
        use_case: data.use_case,
        estimated_volume: data.estimated_volume ?? null,
        source: data.source,
      })
      .select("id")
      .single();
    if (error) {
      console.error("[partnerAccess] insert failed", error);
      return { ok: false as const, error: error.message, code: error.code ?? null };
    }
    return { ok: true as const, id: row?.id ?? null };
  });